"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _TicketMessage = require("./TicketMessage.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WatchMessage = function WatchMessage(_ref) {
  var ticketsLink = _ref.ticketsLink;
  return /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicket, {
    id: "popup-ticket"
  }, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTwoCol, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketColLeft, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTitle, null, "Have free registration?"), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketDesc, null, "You should have received an email with the watch link, please check your spam folder as well. If you have not registered yet, follow the link below and ticket confirmation email will include the watch link."), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketButtonWithBorder, {
    href: ticketsLink,
    target: "blank_"
  }, "Register")), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketColRight, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTitle, null, "Have a paid ticket?"), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketDesc, null, "Please enter your email associated with the ticket order below. If you're not sure, please check an email from the event org team containing direct access link and other useful instructions."), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketForm, {
    action: "/live",
    method: "get",
    target: "_blank",
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketField, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketInput, {
    type: "email",
    name: "email",
    placeholder: "Your email"
  }), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketSubmitButton, {
    type: "submit"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Unlock"), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketArrowSvg, null, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "img/sprite.svg#icon-arrow-right"
  }))))))));
};

var _default = WatchMessage;
exports.default = _default;